import React from 'react'
import Arrow from 'svg/icons/chevron-faq-summit.svg'
import { useThemeContext } from 'contexts/themeContext/hooks'

export function FaqCard({ item, handleToggleFaqCard, activeClass, icon }) {
	const { theme } = useThemeContext()

	return (
		<div
			className={`faq_item ${activeClass && 'active'} ${theme}`}
			onClick={handleToggleFaqCard}
			onKeyDown={handleToggleFaqCard}
			role="button"
			tabIndex={item.id}
			itemScope={true}
			itemProp="mainEntity"
			itemType="http://schema.org/Question"
		>
			<dt className={`faq_title ${activeClass && 'active'} ${theme}`}>
				<h3 itemProp="name">{item.title}</h3>
				<span className={`faq_icon ${activeClass && 'active'} ${theme}`} />
				{icon && <Arrow />}
			</dt>
			<dd
				className="faq_text"
				itemScope={true}
				itemProp="acceptedAnswer"
				itemType="http://schema.org/Answer"
			>
				<span itemProp="text">{item.text}</span>
			</dd>
		</div>
	)
}
